<template>
    <el-dialog
        :title="(isForm ? (formId ? '修改应用套件组' : '添加应用套件组') : '查看') + dialogTitle"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : []" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="分组名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入分组名称"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-form-item label="排序值">
                    <el-input-number
                        v-if="isForm"
                        v-model="formData.list_order"
                        class="mx-4"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                    />
                    <span v-else>{{ formData.list_order }}</span>
                </el-form-item>
                <el-col :span="12">
                    <el-form-item label="分组应用状态">
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio :value="1">正常</el-radio>
                            <el-radio :value="0">停用</el-radio>
                        </el-radio-group>
                        <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref, watch } from 'vue'
import { addAppkitGroup, getAppkitGroupDetail, putAppkitGroup } from '@/api/appkitgroup.js'
import { ElMessage } from 'element-plus'
import { getDictDataSelect } from '@/utils/common.js'
import { getDictDataOptions } from '@/api/dictdata.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    }
})
const presetOptions = ref([])

const emits = defineEmits(['update:modelValue', 'updateForm'])
// 表单源
const formData = ref({
    // id: props.formId,
    name: '',
    list_order: 0,
    status: 1,
    visible: 1,
    group: ''
})
// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入分组名称'
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
// 关闭
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

// 确定按钮点击事件

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.formId !== '') {
        await doputAppkitGroup()
    } else {
        await doaddAppkitGroup()
    }
}

// 修改
const doputAppkitGroup = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await putAppkitGroup(formData.value)
            // 修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 添加
const doaddAppkitGroup = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addAppkitGroup(formData.value)
            // 添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 获取详情
const getAppkitGroupDetailFun = async () => {
    const data = await getAppkitGroupDetail(props.formId)
    dialogTitle.value = '-' + data.name
    formRef.value.resetFields()
    formData.value = data
}

const getList = async () => {
    const dictData = await getDictDataOptions({ dict_code: 'isPreset' })
    presetOptions.value = getDictDataSelect(dictData)
}
onMounted(() => {
    getList()
})
// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getAppkitGroupDetailFun()
        } else {
            formData.value = {
                name: '',
                list_order: 0,
                status: 1,
                visible: 1,
                group: ''
            }
        }
    }
)
</script>

<style lang="scss" scoped></style>
